/* Helper functions */
import { errorLogout } from "./user.service";
import Storage from "./storage.service";
import ErrorMessages from "../static/errors.data";

const setError = (type, code = null) => {
  Storage.set("error", { type: type, code: code });
};

const getErrorObj = (data) => {
  let error_type = data["type"];
  let error_obj = ErrorMessages.error_general;
  if (ErrorMessages[error_type]) {
    error_obj = ErrorMessages[error_type];
  }
  if (data["code"]) {
    error_obj["code"] = data["code"];
  }
  return error_obj;
};

const clearError = () => {
  Storage.clear("error");
  Storage.clear("ok_clear_error_get_status");
  Storage.clear("payment_error");
  Storage.clear("payment_processing");
  Storage.clear("processing_cybersouce");
};

const handleError = (error, callee = "") => {
  let code = getErrorCode(error);
  let type = getErrorType(code);
  if (code === -27) {
    setError(type, code);
  }
  if (code === -199) {
    errorLogout();
  }
  switch (type) {
    case "session_error": // User has been logged out
      errorLogout();
      break;

    default:
      setError(type, code);
      break;
  }
};

const getErrorCode = (error) => {
  if (error) {
    if (error.response) {
      if (error.response.data.code) {
        return error.response.data.code;
      }
      if (error.response.data.error) {
        return error.response.data.error;
      }
      return "ERROR";
    }
    if (typeof error === "string") {
      return error;
    }
  }
  return true;
};

const getErrorType = (code) => {
  let type = "error_general";
  switch (code) {
    case -27: // User has been logged out
    case -7104: // Session and device-id mismatch
    case -7043: // Session and device-id mismatch
      type = "session_error";
      break;

    case -7109:
      type = "payment_error_failed";
      break;

    case -107:
      type = "login_credentials_error";
      break;

    case -7011:
      type = "payment_error_insufficient";
      break;

    case -10012:
      type = "payment_error_transaction_failed";
      break;

    case -7106:
      type = "payment_error_incorrect_details_temp_issue";
      break;

    case -7103:
      type = "payment_error_fraud";
      break;

    case -7105:
      type = "payment_error_incorrect_cvv";
      break;

    case -7110:
      type = "payment_error_transaction_declined";
      break;

    case -7108:
      type = "payment_error_incorrect_details";
      break;

    case -7099:
    case -7111:
    case -10001:
    case -10016:
    case -10013:
    case -10015:
    case -7100:
    case -7059:
    case -7101:
      type = "payment_error_general";
      break;

    case -2015:
      type = "number_already_booked";
      break;

    case -405:
      type = "number_in_transfer";
      break;

    case -440:
      type = "wrong_operator";
      break;

    case -434:
      type = "number_not_activated";
      break;

    case -401:
      type = "delivery_unsupported_for_area";
      break;

    case -128:
      type = "delivery_closed_for_area";
      break;

    case -2010:
      type = "number_expired";
      break;

    case "non_eligible_card":
      type = "non_eligible_card";
      break;

    case "non_recurring_card":
      type = "non_recurring_card";
      break;

    case "account_activated":
      type = "account_activated";
      break;

    default:
      type = "error_general";
      break;

    // case -200: // invalid Email
    // case -435: //Your Email Already Terminated.
  }
  return type;
};

export {
  getErrorCode,
  getErrorObj,
  clearError,
  getErrorType,
  handleError,
  setError,
};
